import { render, staticRenderFns } from "./PasswordReset.vue?vue&type=template&id=47787819"
import script from "./PasswordReset.vue?vue&type=script&lang=ts"
export * from "./PasswordReset.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports